import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Web3 from "web3";

const styles = (theme) => ({
  fill: {
    padding: "0px 8px",
    background: "#00EFAE",
    borderRadius: "24px",
    width: "max-content",
  },
});

const LogoImg = (props) => {
  const { logoImage } = props;
  const web3 = new Web3();

  const [image, setImage] = useState("pools/default.png");

  useEffect(() => {
    const loadLogo = () => {
      try {
        const parsedLogo = web3.utils.hexToUtf8(logoImage);
        setImage(parsedLogo);
      } catch (err) {
        console.error(err);
        setImage(logoImage); // assume it's already parsed
      }
    };

    loadLogo();
  }, [logoImage, web3.utils]);

  return (
    <img
      src={image}
      style={{
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        marginRight: "8px",
      }}
      alt="pool"
      onError={(er) => {
        setImage("pools/default.svg");
      }}
    />
  );
};

export default withStyles(styles)(LogoImg);
